document.addEventListener('click', (event) => {
  const menu = document.querySelector('.v-menu[open]');
  if (menu && (event.target.closest('.v-menu a') || !menu.contains(event.target))) menu.open = false;

  const buyBoxLink = event.target.closest('a[href="#acquista-vyeno"]');
  const buyBox = document.getElementById('acquista-vyeno');
  if (buyBoxLink && buyBox) {
    event.preventDefault();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    buyBox.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    window.history.replaceState(null, '', '#acquista-vyeno');
  }
});
document.addEventListener('keydown', (event) => {
  const menu = document.querySelector('.v-menu[open]');
  if (event.key === 'Escape' && menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  }
});
